import { __assign } from "tslib";
import { ActivityItem, } from '@fluentui/react';
import { ActivityNumLines, } from '@office-start/document-types';
import EdgeworthIcon from '@office-start/edgeworth-icon';
import { getLocalizedDateStringDefault, useTransformDateTimeString, } from '@office-start/loc-service';
import React, { useMemo } from 'react';
import styles from './ActivityControl.module.scss';
import { useReasonTypeIcon } from './hooks/useReasonTypeIcon';
var regex = new RegExp(/({[0-9]+})/, 'gi');
var bracesRegex = new RegExp(/[{}]/, 'gi');
export function createActivityItem(formatString, numLines, dateString, people, id, activityIcon, smallIcon, isCustomStyle, PeopleCard) {
    var stringArray = formatString
        ? formatString.split(regex).filter(function (item) { return item; })
        : [];
    var activityDescriptionElements = [];
    for (var i = 0; i < stringArray.length; i++) {
        if (stringArray[i].match(regex) && people.length > 0) {
            var peopleIndexString = stringArray[i].replace(bracesRegex, '');
            try {
                var peopleIndex = parseInt(peopleIndexString);
                if (people[peopleIndex]) {
                    var key = id + i + 'link';
                    var className = isCustomStyle
                        ? styles['custom-activity-link']
                        : styles['activity-link'];
                    if (PeopleCard) {
                        activityDescriptionElements.push(React.createElement(PeopleCard, { upn: people[peopleIndex].upn, key: key },
                            React.createElement("a", { className: className }, people[peopleIndex].name)));
                    }
                    else {
                        activityDescriptionElements.push(React.createElement("span", { className: className, key: key }, people[peopleIndex].name));
                    }
                    continue;
                }
            }
            catch (_e) {
                /* do nothing */
            }
        }
        else {
            activityDescriptionElements.push(stringArray[i]);
        }
    }
    var activityItemProps = {
        activityIcon: (React.createElement("div", { className: smallIcon
                ? styles['activity-icon--small']
                : styles['activity-icon'] },
            React.createElement(EdgeworthIcon, { iconName: activityIcon }))),
        activityDescription: activityDescriptionElements,
    };
    if (numLines === ActivityNumLines.Two) {
        activityItemProps.timeStamp = dateString;
    }
    return activityItemProps;
}
export var ActivityControl = function (_a) {
    var formatString = _a.formatString, _b = _a.numLines, numLines = _b === void 0 ? ActivityNumLines.One : _b, people = _a.people, reasonType = _a.reasonType, timestamp = _a.timestamp, plainText = _a.plainText, _c = _a.smallIcon, smallIcon = _c === void 0 ? false : _c, id = _a.id, preferredCulture = _a.preferredCulture, dateResources = _a.dateResources, PeopleCard = _a.PeopleCard;
    var transformToDateTimeString = useTransformDateTimeString(dateResources, preferredCulture);
    var fallbackText = timestamp
        ? getLocalizedDateStringDefault(timestamp, preferredCulture)
        : undefined;
    var activityIcon = useReasonTypeIcon(reasonType);
    var activityItem = useMemo(function () {
        return createActivityItem(formatString, numLines, transformToDateTimeString(timestamp, false, fallbackText, false), people, id, activityIcon, smallIcon, false, PeopleCard);
    }, [
        activityIcon,
        fallbackText,
        formatString,
        id,
        numLines,
        people,
        smallIcon,
        timestamp,
        transformToDateTimeString,
        PeopleCard,
    ]);
    var activityItemStyles = {
        activityContent: styles['activity-content'],
        activityText: styles['activity-text'],
        activityTypeIcon: styles['activity-type-icon'],
        timeStamp: styles['activity-timestamp'],
    };
    return (React.createElement(ActivityItem, __assign({ className: styles['activity-item'], styles: activityItemStyles, title: plainText }, activityItem, { key: activityItem.id })));
};
//# sourceMappingURL=ActivityControl.js.map